import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components/native';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { SafeAreaView, TextInput, View } from 'react-native';

import { BasicText, SmallLabel } from '../Styles';
import { DataContext } from 'opidcore';
import moment from 'moment';
import { update } from 'lodash';

const CalendarContainer = styled.SafeAreaView`
    margin: 12px;
    background: #FFFFFF;
`;

const InputContainer = styled.TouchableOpacity`
    margin: 12px;
    padding: 5px;
    border-width: 1px;
    border-color: #aaaaaa;
    border-radius: 4px;
`;

const CustomInput = ({ value = undefined, onClick = undefined, onChange = undefined, disabled = false}) => {
    const [valueState, setValueState] = useState(value);

    useEffect(()=>{
        setValueState(value);
    }, [value]);

    const changeEvent = (event) =>{
        setValueState(event.target.value);
    }

    return <InputContainer onPress={onClick}>
        <TextInput value={valueState} onChange={changeEvent} disabled={disabled}/>
    </InputContainer>
};

const WebDatePicker = ({field, label = undefined, dateFormat = "YYYY-MM-DD", includeDateIntervals = [], readOnly = false, disabled = false}) => {
    const boundMagic = useContext(DataContext);
    const [value, setValue] = useState(null);

    const updateState = (newValue) => {
        if(typeof newValue == "string"){
            if(newValue.trim().length == 0){
                newValue = null;
            } else {
                newValue = moment(newValue).toDate();
            }
        } else if(moment.isMoment(newValue)){
            newValue = newValue.toDate();
        } else if(newValue instanceof Date && !isNaN(newValue.getTime())){
            //this is what we want
        } else {
            console.log("invalid format date format");
            newValue = null;
        }

        setValue(newValue);
    }

    useEffect(()=>{
        boundMagic.magicalState(field, updateState);
    }, [boundMagic]);

    const setDate = (date) => {
        const newValue = moment.utc(date).format(dateFormat);
        boundMagic.magicalSet(field, newValue);
    };

    return <View style={{zIndex: 1, alignItems: "center", flexDirection: "row"}}>
        {label == undefined? null : <SmallLabel>{label}</SmallLabel>}
        {readOnly == true? 
            <BasicText>{moment(value).format(dateFormat)}</BasicText> :
            <DatePicker
                selected={value}
                dateFormat={"yyyy-MM-dd"}
                onChange={setDate}
                placeholderText={"yyyy-MM-dd"}
                calendarContainer={CalendarContainer}
                customInput={<CustomInput disabled={disabled}/>}
                disabled={disabled}
            />
        }
    </View>;
}

export default WebDatePicker;